<template>
  <div class="fixed-top">
    <div class="flex-c mt100">
      <img src="../../assets/images/success.png" show-menu-by-longpress alt />
      <span class="f36 color-333 fb ml10">提交成功</span>
    </div>
    <div class="flex-c flex-dc f26 color-A mb200 mt100">
      <span class="mt10">感谢您的填写，有任何问题可以随时联系班主任~</span>
    </div>
    <div class="footer-box footer" @click="openApp">
      <gxxt-button type="primary" style="width: 100%">下载APP</gxxt-button>
    </div>
  </div>
</template>
<script>
export default {}
</script>

<style lang="less" scoped>
.fixed-top {
  width: 750px;
  left: 50%;
  margin-left: -375px;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
}

.footer-box {
  width: 686px;
  height: 80px;
  line-height: 80px;
  margin: 0 auto;
  border-radius: 12px;
  box-sizing: border-box;
  color: #fff;
  font-size: 32px;
  background: linear-gradient(90deg, #ff8e00 0%, #ff5500 100%);
}

.img-box {
  width: 200px;
  height: 200px;
  margin: 100px 0 26px 0;
}
</style>
